import { SEARCH, SHOPS } from 'config/fe-routes';
import { useRouter } from 'next/router';
import React from 'react';
import { cleanQueryParams, redirectTo } from 'utils/route-helpers';

import HeaderSearch from '../HeaderSearch/HeaderSearch';

type Props = {
  onSearch?: (searchKey: string) => void;
};

const HeaderGlobalSearch = (props: Props) => {
  const { onSearch } = props;
  const { route, query } = useRouter();
  const search: any = query?.search;

  return (
    <HeaderSearch
      placeholder="components.search-bar.search-placeholder"
      search={search}
      onSearch={async (searchValue) => {
        // If not empty, do search
        const replace = route === SEARCH(searchValue).href;

        await redirectTo(
          {
            ...SEARCH(searchValue || ''),
            query: cleanQueryParams({
              ...query,
              search: undefined,
              replace: undefined,
              source_module: undefined,
              section: SHOPS().href === route ? 'shops' : '',
            }),
            opts: {
              scroll: !replace, // Keep scroll position if route is replaced.
            },
          },
          replace,
        );

        if (typeof onSearch === 'function') {
          onSearch(searchValue);
        }
      }}
    />
  );
};

export default HeaderGlobalSearch;
